var map = {
	"./Slide01-a.PNG": 554,
	"./Slide01-b.PNG": 620,
	"./Slide02-a.PNG": 8423,
	"./Slide02-b.PNG": 5091,
	"./Slide03-a.PNG": 9301,
	"./Slide03-b.PNG": 1917,
	"./Slide04-a.PNG": 5165,
	"./Slide04-b.PNG": 3616,
	"./Slide05-a.PNG": 4361,
	"./Slide05-b.PNG": 1301,
	"./Slide06-a.PNG": 1613,
	"./Slide06-b.PNG": 4793,
	"./Slide07-a.PNG": 3555,
	"./Slide07-b.PNG": 4325,
	"./Slide08-a.PNG": 7513,
	"./Slide08-b.PNG": 424,
	"./Slide09-a.PNG": 6842,
	"./Slide09-b.PNG": 8639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9958;